import {MRT_Row} from 'material-react-table';
import React from 'react';
import {Body, designSystemToken} from '@lightricks/react-design-system';
import getFormattedPastDate from '@/utils/getFormattedPastDate';
import {type BrandedContentAdsPartnership} from '@/types/brandedContentAdsPartnership';

function CreatedCell({row}: {row: MRT_Row<BrandedContentAdsPartnership>}) {
  const formatTimeAgo = (dateString: string) => {
    try {
      return getFormattedPastDate(new Date(dateString));
    } catch {
      return '';
    }
  };

  return (
    <Body size="md" color={designSystemToken('semantic.fg.secondary')}>
      {row.original.createdAt ? formatTimeAgo(row.original.createdAt) : ''}
    </Body>
  );
}

export default CreatedCell;
